// extracted by mini-css-extract-plugin
module.exports = {"containerWithBG":"App_containerWithBG__2GKxO","bottom":"App_bottom__2KHjy","top":"App_top__3N23O","faqContainer":"App_faqContainer__1m6Q5"};